import React from "react";

import type { IBaseComponent } from "../models/formFields";
import { notEmpty } from "../utils/functional";
import { getErrorListElemID, showValidationErrors } from "./hooks/formUtils";

/**
 * Renders validation errors
 */
export const FormValidationError = (
    props: IBaseComponent & {
        id?: string;
    },
): React.ReactNode => {
    if (!props.errors || !showValidationErrors(props)) {
        return null;
    }
    const elemID = props.id ? getErrorListElemID(props.id) : undefined;
    const errors = props.errors.filter(notEmpty).map((msg) => {
        return (
            <li
                className="form__error"
                key={msg}
                dangerouslySetInnerHTML={{ __html: msg }}
            />
        );
    });
    return (
        <ul id={elemID} className="form__error-list">
            {errors}
        </ul>
    );
};
